import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { m } from '../../../utils';

const StartTimeSelect = ({ shifts, handleStartTimeFilter, startTime }) => (
  <div className="filter-container">
    <h4 className="filter-title">Start Time</h4>
    <div className="filter-content ">
      <div className="select-field">
        <SelectField
          fullWidth
          labelStyle={{ color: '#fafafa' }}
          selectedMenuItemStyle={{
            color: '#F5F5F5',
            backgroundColor: '#33691E',
          }}
          onChange={(e, i, v) => {
            handleStartTimeFilter(v);
          }}
          value={startTime}>
          {shifts.map(shift => <MenuItem key={shift.id} value={shift.hour} primaryText={m(shift.time).format('LT')} />)}
        </SelectField>
      </div>
    </div>
  </div>
);

export default StartTimeSelect;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/StartTimeSelect.js